import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import InstalledApps from '../../components/InstalledApps';
import AvailableApps from '../../components/AvailableApps';
import Loading from '../../components/Loading';
import { getApplications } from '../../actions/applications';

import Header from '../Header';

const useStyles = makeStyles(theme => ({
  wrapper: {
    paddingTop: theme.spacing(10),
  },
  sectionTitle: {
    borderBottom: '2px solid #DFDFDF',
    padding: theme.spacing(3),
  },
  appCardList: {
    '& > div:nth-child(odd)': {
      borderRight: '2px solid #DFDFDF',
      [theme.breakpoints.down('xs')]: {
        borderRight: 'none',
      },
    },
  },
}));

function Home({ getApps }) {
  useEffect(() => {
    getApps();
  }, [getApps]);

  const classes = useStyles();

  return (
    <>
      <Loading />
      <Header activeNavItem="Home" />
      <Container className={classes.wrapper} maxWidth="lg">
        <Grid container spacing={6}>
          <Grid item xs={12} sm={12}>
            <div className={classes.sectionTitle}>
              <Typography variant="h5" component="h3">
                Installed Apps
              </Typography>
            </div>
            <Grid container className={classes.appCardList}>
              <InstalledApps />
            </Grid>
            <div className={classes.sectionTitle}>
              <Typography variant="h5" component="h3">
                Other Episource Apps
              </Typography>
            </div>
            <div>
              <AvailableApps />
            </div>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

Home.defaultProps = {
  getApps: () => {},
};

Home.propTypes = {
  getApps: PropTypes.func,
};

const mapDispatchToProps = {
  getApps: getApplications,
};

export default connect(() => ({}), mapDispatchToProps)(Home);
